"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// See JSON schema in README.md
var modelPropTypes = {
  iconType: _propTypes["default"].oneOf(["species", "image"]).isRequired,
  iconSrc: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].shape({
    text: _propTypes["default"].string,
    url: _propTypes["default"].string
  }),
  content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string.isRequired,
    url: _propTypes["default"].string
  }))
};
var _default = exports["default"] = modelPropTypes;